/**
 * The /vector FAQ copy, in one place.
 *
 * `VectorPageContent.tsx` renders these as the visible FAQ section and
 * `page.tsx` builds the FAQPage JSON-LD from the same array, so the schema and
 * the answers on screen cannot drift apart — which is what Google requires of
 * FAQPage markup.
 *
 * It lives in its own module rather than beside the section that renders it
 * because `VectorPageContent.tsx` is a Client Component: importing a value
 * across that boundary hands the server a client reference, not the array
 * (`FAQS.map is not a function` at build time).
 */
export const FAQS = [
  [
    'What exactly are we buying?',
    'A fixed-scope qualification application configured to your ICP, CRM, evidence, scoring weights, and routing rules. You own that application code. Pixelmojo maintains the underlying intelligence platform and model operations.',
  ],
  [
    'How does the pricing work?',
    'The current offer is $35,000 for the 60-day build, $1,500 per month for the intelligence platform, and 5% of deal value from Vector-qualified leads that close. The platform has a 12-month minimum.',
  ],
  [
    'Which teams are the best fit?',
    'Growth-stage B2B SaaS teams with roughly 50–200 or more inbound leads per month, an existing CRM, a defined ICP, and a seller ready to receive qualified opportunities.',
  ],
  [
    'What happens when Vector is wrong?',
    'Every decision is logged with its rationale. Your team receives a daily filtered-lead report, can override any route with one click, and compares Vector’s calls against actual outcomes every week.',
  ],
  [
    'Which CRMs can Vector connect to?',
    'Vector is designed for standard CRM setups including HubSpot, Salesforce, and Pipedrive. Exact fields, ownership rules, and handoff workflows are defined during the build.',
  ],
  [
    'Can our team maintain the application?',
    'Yes. The application uses a standard production stack such as Next.js, PostgreSQL, and standard APIs. Your team receives source access and controls the infrastructure, so it can maintain, extend, or migrate the application.',
  ],
] as const
